<div class="modal-content-attention modal-content-attention-success">
  <div class="modal-content-container">
    <div class="modal-icon modal-icon-success"></div>

    <div class="modal-title">Successful!</div>

    <div class="modal-message">You have successfully {{ isReset ? 'reset' : 'created' }} a Service Account.</div>

    <div class="flex flex-col gap-2 border border-skeleton px-4 py-3 rounded-lg w-full mt-4 break-anywhere">
      <div id="api-keys">
        <div class="text-font-secondary">API Key ID:</div>
        <div class="font-semibold text-base">{{ apiKeyId | uppercase }}</div>
        <div>&nbsp;</div>
        <div class="text-font-secondary">API Secret:</div>
        <div class="font-semibold text-base">{{ apiKeySecret }}</div>
      </div>
      <div class="flex flex-1 justify-center mt-2">
        <div class="relative">
          <button rktButton btnType="secondary" class="!px-3 !py-2" (click)="copyToClipboard()">Copy</button>

          @if (copyFlag) {
            <div class="absolute left-full flex gap-1 items-center top-[0.625rem] text-nowrap ml-3">
              <rkt-icon name="check" class="text-[#43CA21] shrink-0 text-xl"></rkt-icon>Copied to clipboard
            </div>
          }
        </div>
      </div>
    </div>

    <div class="flex gap-2 font-semibold mt-5">
      <rkt-icon name="error" class="text-[#FFB257] flex-shrink-0 inline-flex text-2xl" />
      Store ths API Key ID and Secret somewhere safe. It will not be visible again once you close this dialog.
    </div>

    <div class="modal-buttons">
      <button rktButton title="Done" (click)="activeModal.close(true)">Done</button>
    </div>
  </div>
</div>
